import {
    addSmartTask,
    createSmartTaskReminder,
} from './getSmartTodosOrRemindersForItem.locstring.json';
import loc from 'owa-localize';
import createSmartTodoPillData from './createSmartTodoPillData';
import createSmartReminderPillData from './createSmartReminderPillData';
import parseSmartTaskProperty from './parseSmartTaskProperty';
import getSmartTaskPropertyFromItem from './getSmartTaskPropertyFromItem';
import Message from 'owa-service/lib/contract/Message';
import ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import { ClientItem } from 'owa-mail-store';
import { SmartPillData } from 'owa-smart-pill';
import { trace } from 'owa-trace';
import { TaskType } from './constants';
import { lazyGetItemProperties } from 'owa-get-item-manager';
import { GetItemManagerFeatureIds } from 'owa-mail-smart-pill-features';

/**
 * @param item - The client item for the pill
 * @param taskType - The type of task pill (reminder or to do) that's being retrieved
 */
export default async function getSmartTodosOrRemindersForItem(
    item: ClientItem,
    taskType: TaskType
): Promise<SmartPillData[]> {
    if (item) {
        if (!item.SmartTaskData) {
            const getItemProperties = await lazyGetItemProperties.import();
            const itemWithProperty: ClientItem = (await getItemProperties(
                item.ItemId.Id,
                GetItemManagerFeatureIds.SmartTask
            )) as ClientItem;

            // At this point, if itemWithProperty exists, it should be the same as the item input into this function.
            if (itemWithProperty) {
                const extendedProperty: ExtendedPropertyType = getSmartTaskPropertyFromItem(
                    itemWithProperty
                );

                parseSmartTaskProperty(itemWithProperty, extendedProperty);
            }
        }

        if (item.SmartTaskData?.SmartTasks) {
            return item.SmartTaskData.SmartTasks.map((smartTask, index) => {
                if (taskType == TaskType.Todo) {
                    if (item.ItemId) {
                        return createSmartTodoPillData(
                            smartTask,
                            item.ItemId.Id,
                            loc(addSmartTask),
                            index
                        );
                    }
                }

                return createSmartReminderPillData(
                    smartTask,
                    item.ItemId.Id,
                    (item as Message).InternetMessageId,
                    loc(createSmartTaskReminder),
                    index
                );
            });
        }
    } else {
        trace.info('[getSmartTodosOrRemindersForItem] No item, cannot produce smart tasks.');
    }

    return [];
}
